import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface Preferito {
  idTestata?: number;
  idEdizione?: number;
  tipo: 'testata' | 'edizione';
  idRiferimento: number;
  nomeTestata?: string;
  nomeEdizione?: string;
  dataCreazione: string;
}

export interface PreferitiList {
  message?: { code: string; message: string; type: string };
  data: Preferito[];
}

export interface PreferitoRequest {
  tipo: 'testata' | 'edizione';
  idRiferimento: number;
}

export interface PdfResponse {
  message?: { code: string; message: string; type: string };
  data: string; // Base64-encoded PDF
}

const PREFERITI_ENDPOINT = '/fo/preferiti';
const EDIZIONI_ENDPOINT = '/fo/edizioni';
@Injectable({
  providedIn: 'root',
})
export class PreferitiService {
  apiService = inject(ApiService);

  getPreferiti(): Observable<PreferitiList> {
    return this.apiService.get<PreferitiList>(PREFERITI_ENDPOINT);
  }

  addPreferito(request: PreferitoRequest): Observable<void> {
    return this.apiService.post<void>(PREFERITI_ENDPOINT, request);
  }

  deletePreferito(id: number): Observable<void> {
    return this.apiService.delete<void>(`${PREFERITI_ENDPOINT}/${id}`);
  }

  getEdizionePdf(idEdizione: number | string): Observable<PdfResponse> {
    return this.apiService.get<PdfResponse>(`${EDIZIONI_ENDPOINT}/${idEdizione}/pdf`);
 }

  // New OpenAPI-specific endpoints
  postPrefTestata(request: { idTestata: number; azione: 'A' | 'D' }): Observable<any> {
    const xsrf = this.apiService.getXsrfToken();
    const headers = xsrf ? { 'X-XSRF-TOKEN': xsrf } : undefined;
    return this.apiService.post<any>(`${PREFERITI_ENDPOINT}/testata`, request, headers);
  }

  postPrefEdizione(request: { idEdizione: number; azione: 'A' | 'D' }): Observable<any> {
    const xsrf = this.apiService.getXsrfToken();
    const headers = xsrf ? { 'X-XSRF-TOKEN': xsrf } : undefined;
    return this.apiService.post<any>(`${PREFERITI_ENDPOINT}/edizioni`, request, headers);
  }

  getEdizioniPreferite(page?: number, pageSize?: number): Observable<any> {
    const params: any = {};
    if (page !== undefined) params.page = page;
    if (pageSize !== undefined) params.pageSize = pageSize;
    return this.apiService.get<any>( `${PREFERITI_ENDPOINT}/edizioni` , params);
  }
}
